import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, FormControl, Validators } from '@angular/forms';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { ApiService } from 'src/app/service/api.service';
import { DesignService } from 'src/app/service/design.service';
import { TreeNodeService } from 'src/app/shared/services/treedata.service';
import { Router } from '@angular/router';
import { ProfileService } from 'src/app/shared/services/profile.service';

@Component({
  selector: 'app-wizard-tree-selection',
  templateUrl: './wizard-tree-selection.component.html',
  styleUrls: ['./wizard-tree-selection.component.scss']
})
export class WizardTreeSelectionComponent implements OnInit {

  constructor(
    private ApiService: ApiService,
    private treeService: TreeNodeService,
    private router: Router,
    private dbService: NgxIndexedDBService,
    private designService: DesignService,
    private profileService: ProfileService
  ) { }

  //inject senare
  // gedcomId: string;
  @Input() gedcomId: string = '';
  design: any;
  selectStartPerson = new UntypedFormControl('', Validators.required);
  papertype = 'A0'
  gedcom: any;
  individuals: any = [];
  selectBackground: string = "";
  selectedDesign: any;
  paperSizes: string[] = ['A0', 'A1', 'A2'];
  singles: any;
  couples: any;
  nodeinfos = {};
  coupleinfos = {};
  designs: any = [];
  profile: any;
  backgrounds: any = [
    { img: "./assets/image/landscape/mini/Bakg5-ligg-mini.jpg", svgPath: 'assets/image/landscape/Bakg5-ligg.svg' },
    { img: "./assets/image/landscape/mini/Bakg8-ligg-mini.jpg", svgPath: 'assets/image/landscape/Bakg8-ligg.svg' },
    { img: "./assets/image/landscape/mini/Bakg9-ligg-mini.jpg", svgPath: 'assets/image/landscape/Bakg9-ligg.svg' },
    { img: "./assets/image/landscape/mini/Bakg4-ligg-mini.jpg", svgPath: 'assets/image/landscape/Bakg4-ligg.svg' },
    { img: "./assets/image/landscape/mini/Bakg5-ligg-mini.jpg", svgPath: 'assets/image/landscape/Bakg5-ligg.svg' },
    { img: "./assets/image/landscape/mini/Bakg8-ligg-mini.jpg", svgPath: 'assets/image/landscape/Bakg8-ligg.svg' },
    { img: "./assets/image/landscape/mini/Bakg9-ligg-mini.jpg", svgPath: 'assets/image/landscape/Bakg9-ligg.svg' },
    { img: "./assets/image/landscape/mini/Bakg4-ligg-mini.jpg", svgPath: 'assets/image/landscape/Bakg4-ligg.svg' },
  ]

  onKeySingle(value) {
    this.individuals = this.searchSingle(value);
  }

  searchSingle(value: string) {
    let filter = value.toLowerCase();
    return this.individuals.filter(option => ((option['firstName'] ?? "") + (option['lastName'] ?? "")).toLowerCase().includes(filter));
  }

  validate() {
    if (this.selectStartPerson.valid && this.selectedDesign) {
      return false
    }
    else {
      return true
    }
  }

  generateTree() {

    let width, height, maxgeneration, paperType

    switch (this.papertype) {
      case 'A0':
        paperType = this.papertype
        width = '67408';
        height = '47679';
        maxgeneration = 10;
        break;
      case 'A1':
        paperType = this.papertype
        width = '47679';
        height = '33676';
        maxgeneration = 8;
        break;
      case 'A2':
        paperType = this.papertype
        width = '33676';
        height = '23811';
        maxgeneration = 7;
        break;
      case 'A3':
        paperType = this.papertype
        width = '23811';
        height = '16838';
        maxgeneration = 6;
        break;
      case 'A4':
        paperType = this.papertype
        width = '16838';
        height = '11906';
        maxgeneration = 5;
        break;

      default:
        paperType = 'A0'
        width = '67408';
        height = '47679';
        maxgeneration = 10;
        break;
    }

    localStorage.setItem("maxGeneration", maxgeneration);
    localStorage.setItem("tree_width", width);
    localStorage.setItem("tree_height", height);
    localStorage.setItem("papertype", this.papertype);

    localStorage.setItem("type", 'single');
    localStorage.setItem("id", this.selectStartPerson.value);
    localStorage.setItem('background', this.selectedDesign.data.background ? this.selectedDesign.data.background : "")
    localStorage.setItem("gedcom_id", this.gedcomId);
    localStorage.setItem("direction", this.selectedDesign.data.direction ? this.selectedDesign.data.direction : "5");
    localStorage.setItem('manColor', this.selectedDesign.data.manColor ? this.selectedDesign.data.manColor : '#000000')
    localStorage.setItem('womanColor', this.selectedDesign.data.womanColor ? this.selectedDesign.data.womanColor : '#000000')
    localStorage.setItem('maleNodeColor', this.selectedDesign.data.maleNodeColor ? this.selectedDesign.data.maleNodeColor : '#ffffff')
    localStorage.setItem('femaleNodeColor', this.selectedDesign.data.femaleNodeColor ? this.selectedDesign.data.femaleNodeColor : '#ffffff')
    localStorage.setItem('borderColor', this.selectedDesign.data.borderColor ? this.selectedDesign.data.borderColor : '#000000')
    localStorage.setItem('borderWidth', this.selectedDesign.data.borderWidth ? this.selectedDesign.data.borderWidth : '2');
    localStorage.setItem('backOpacity', this.selectedDesign.data.backOpacity ? this.selectedDesign.data.backOpacity : '1')
    localStorage.setItem('nodeOpacity', this.selectedDesign.data.nodeOpacity ? this.selectedDesign.data.nodeOpacity : '1')
    localStorage.setItem('cornerRound', this.selectedDesign.data.borderRadius ? this.selectedDesign.data.borderRadius : '50')
    localStorage.setItem('global_padding', this.selectedDesign.data.global_padding ? this.selectedDesign.data.global_padding : '5')
    localStorage.setItem('empty_node_setting', this.selectedDesign.data.empty_node_setting ? this.selectedDesign.data.empty_node_setting : 'none');
    localStorage.setItem('text_align', this.selectedDesign.data.text_align ? this.selectedDesign.data.text_align : 'middle');
    localStorage.setItem('name_text_align', this.selectedDesign.data.name_text_align ? this.selectedDesign.data.name_text_align : 'middle');
    localStorage.setItem('birth_setting', this.selectedDesign.data.birthSetting ? this.selectedDesign.data.birthSetting : 'block');
    localStorage.setItem('marriage_setting', this.selectedDesign.data.marriageSetting ? this.selectedDesign.data.marriageSetting : 'block');
    localStorage.setItem('death_setting', this.selectedDesign.data.deathSetting ? this.selectedDesign.data.deathSetting : 'block');
    localStorage.setItem('partner_setting', 'SHOW'); //Missing from design
    localStorage.setItem('children_setting', 'SHOW'); //Missing from design
    localStorage.setItem('flag_setting', this.selectedDesign.data.flag_setting ? this.selectedDesign.data.flag_setting : 'HIDE');
    localStorage.setItem('profile_setting', this.selectedDesign.data.profile_setting ? this.selectedDesign.data.profile_setting : 'SHOW');
    localStorage.setItem('warning_setting', this.selectedDesign.data.warning_setting ? this.selectedDesign.data.warning_setting : 'HIDE');
    let temp1 = this.treeService.dateString(this.nodeinfos);

    // localStorage.setItem("nodeinfos", JSON.stringify(temp1))
    let nodeinfos = JSON.stringify(temp1)
    // localStorage.setItem("coupleinfos", JSON.stringify(this.coupleinfos))

    let coupleinfos = JSON.stringify(this.coupleinfos)
    // Delete store before insert
    this.dbService.deleteByKey('nodes', 1).subscribe((status) => {
      console.log('Deleted?:', status);
    }, err => console.log(err));
    // console.log(coupleinfos)
    this.dbService
      .add('nodes', {
        id: 1,
        nodeinfos: nodeinfos,
        coupleinfos: coupleinfos,
      })
      .subscribe((key) => {
      });
      
    
    this.profile.wizard_completed = true;
    this.profileService.updateProfile(this.profile).then((res: any) =>{
      // Try to pass nodes info and coupleinfos to component.
      this.router.navigateByUrl('/dashboard/main');
    }, err => console.log(err)) // Show err
  }

  ngOnInit(): void {
    this.profileService.getUserProfilePromise().then((user: any) => {
      this.profile = user.data();
    })
    localStorage.setItem('gedcom_id', this.gedcomId);

    this.designService.getWizardDesigns().subscribe((designs: any) => {
      this.designs = []
      for (let index = 0; index < 8; index++) {
        const element = designs[index];
        this.designs.push({ id: element.payload.doc.id, data: element.payload.doc.data() })
      }
      this.designs.sort((a: any, b: any) => {
        return a.data.direction - b.data.direction;
      });
    }, err => console.log(err))


    this.ApiService.getGedcom(this.gedcomId).then((gedcom: any) => {
      this.individuals = gedcom.indis;

      this.gedcom
      for (let index = 0; index < this.individuals.length; index++) {
        const element = this.individuals[index];

      }
      this.couples = gedcom.fams;
      this.couples.forEach(data => {
        this.coupleinfos[data.id] = data;
      });
      this.individuals.forEach(data => {
        this.nodeinfos[data.id] = data;
        this.nodeinfos[data.id]['country'] = ""
        this.nodeinfos[data.id]['avatar_type'] = "sample"
        this.nodeinfos[data.id]['c_flag'] = ""
        this.nodeinfos[data.id]['father'] = (data['famc'] && this.coupleinfos[data['famc']]['husb']) ? this.coupleinfos[data['famc']]['husb'] : "";
        this.nodeinfos[data.id]['mother'] = (data['famc'] && this.coupleinfos[data['famc']]['wife']) ? this.coupleinfos[data['famc']]['wife'] : "";
        this.nodeinfos[data.id]['marriage'] = [];
        this.nodeinfos[data.id]['wife'] = [];
        this.nodeinfos[data.id]['husb'] = [];
        this.nodeinfos[data.id]['child_info'] = [];
        this.nodeinfos[data.id]['avatar_setting'] = 'SHOW';
        this.nodeinfos[data.id]['note'] = '';
        this.nodeinfos[data.id]['warning'] = false;

        if (data['fams']) {
          data['fams'].forEach(item => {
            this.nodeinfos[data.id]['marriage'] = { [item]: this.coupleinfos[item].marriage };

            if (data['sex'] == 'M') {
              if (this.coupleinfos[item].wife) this.nodeinfos[data.id]['wife'].push(this.coupleinfos[item].wife);
            }
            else {
              if (this.coupleinfos[item].husb) this.nodeinfos[data.id]['husb'].push(this.coupleinfos[item].husb);
            }
            this.coupleinfos[item].children.forEach(child => {
              this.nodeinfos[data.id]['child_info'].push(child);
            })
          })
        }
        else {
          this.nodeinfos[data.id]['wife'] = [];
          this.nodeinfos[data.id]['child_info'] = [];
        }
        this.selectStartPerson.patchValue(this.individuals[0].id)
      });
    })
  }
}
